import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { BASE_URL } from "../../config/config";

export const AcceptProperty = createAsyncThunk(
  "property/accept",
  async (id, { rejectWithValue }) => {
    try {
      // Get token dynamically at call time
      const token = sessionStorage.getItem("ots_token") || localStorage.getItem("ots_token");
      const res = await axios.put(
        `${BASE_URL}/admin/update-property-status/${id}`,
        { status: "accepted" },
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      return res.data;
    } catch (error) {
      const message = error.data?.message || error.response?.data?.message || error.message || "Failed to approve property";
      return rejectWithValue({ message });
    }
  }
);

export const RejectProperty = createAsyncThunk(
  "property/reject",
  async ({ id, reason, is_editable }, { rejectWithValue }) => {
    try {
      // Get token dynamically at call time
      const token = sessionStorage.getItem("ots_token") || localStorage.getItem("ots_token");
      const res = await axios.put(
        `${BASE_URL}/admin/update-property-status/${id}`,
        { status: "rejected", rejectionReason: reason, is_editable },
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      return res.data;
    } catch (error) {
      const message = error.data?.message || error.response?.data?.message || error.message || "Failed to reject property";
      return rejectWithValue({ message });
    }
  }
);

const AcceptPropertySlice = createSlice({
  name: "AcceptProperty",
  initialState: {
    loading: false,
    data: null,
    error: null,
  },
  extraReducers: (builder) => {
    builder
      .addCase(AcceptProperty.pending, (state) => {
        state.loading = true;
      })
      .addCase(AcceptProperty.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(AcceptProperty.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })
      // Reject Property
      .addCase(RejectProperty.pending, (state) => {
        state.loading = true;
      })
      .addCase(RejectProperty.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(RejectProperty.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });
  },
});

export default AcceptPropertySlice.reducer;
